import { Logger } from "@visactor/vutils";

export const error = message => {
    Logger.getInstance().error(message);
};
//# sourceMappingURL=error.js.map